<button mat-button
        [matMenuTriggerFor]="menu"
        [disabled]="!isReady"
        [attr.aria-label]="text">
    <mat-icon>menu</mat-icon>
</button>
<mat-menu #menu="matMenu">
    <button *ngFor="let menuItem of menuDataItems"
            mat-menu-item
            (click)="menuItem.action(viewModel)"
            [disabled]="!menuItem.isEnabled">
        <mat-icon *ngIf="menuItem.icon" [svgIcon]="menuItem.icon"></mat-icon>
        <mat-icon *ngIf="menuItem.materialIcon">{{menuItem.materialIcon}}</mat-icon>
        <span>{{menuItem.text}}</span>
    </button>
</mat-menu>
